import CONSTANTS from "../../assets/js/Constants"

// import { createBrowserHistory } from 'history'

// const history = createBrowserHistory({
//     forceRefresh: true, // Set true to force full page refreshes
// })

const configCalendar = {
   calenderMaintananceConfig: {
      id: "1",
      username: "",
      kmGps: {},
      timeActive: new Date(),
      vehicles: [],
      kmMaintanance: ["1", "5", "10"],
      timeCycle: { v1: "1", v2: "3", v3: "6" },
      timeActiveCycle: { v1: "1h", v2: "3h", v3: "6h" },
      listItem: [
         {
            index: 1,
            todo: { id: "1", name: "Thay dầu động cơ", action: 0 },
            v1: "KT",
            v2: "TT",
            v3: "TT"
         },
         {
            index: 2,
            todo: { id: "2", name: "Thay vỏ bánh xe", action: 0 },
            v1: "TT",
            v2: "KT",
            v3: ""
         },
         {
            index: 3,
            todo: { id: "3", name: "Thay nhíp", action: 0 },
            v1: "TT",
            v2: "KT",
            v3: "TT"
         }
      ]
   },
   calenderReminderConfig: {},
   todoList: [],
   providers: []
}
export default function (state = configCalendar, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.GET_LIST:
         return { ...state }

      case CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.UPDATE_PROVIDERS_TODOLIST:
         return { ...state, ...payload }

      case CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.UPDATE_CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION:
         return {
            ...state,
            calenderMaintananceConfig: {
               ...payload
            }
         }

      case CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_DOCUMENT_CONFIG:
         return { ...state, calenderReminderConfig: { ...state.calenderReminderConfig, documentConfig: payload } }

      case CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.GET_REMINDER_MAINTANANCE_CONFIG:
         return { ...state, calenderReminderConfig: { ...state.calenderReminderConfig, maintananceConfig: payload } }

      // case GET_KM_BEGIN_END
      case CONSTANTS.ACTION.CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION.SET_KM_BEGIN_END:
         return { ...state, calenderMaintananceConfig: { ...state.calenderMaintananceConfig, ...payload } }

      default:
         return { ...state }
   }
}
